<template>
  <div>
    <div
      class="error-box"
    >
      <div class="level-left">
        <div class="level-item">
          <div>
            <p class="is-size-2 has-text-weight-bold">
              <font-awesome-icon
                icon="exclamation-circle"
                class="error-icon"
              />
              {{ $t('domains.error.try_again') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  name: 'SearchError',
  props: {
    searchError: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.error-box {
  background: var(--warning);
  color: $white;
  padding: 30px 30px 40px;
  margin-top: 15px;
}
.error-icon {
  margin-right: 5px;
  font-size: 25px;
}

</style>
